import React from "react";
import { formatCLP } from "../../Helper/Cotizacion/currencyUtils";
import CotizacionStatusBadge from "./CotizacionStatusBadge";

const QuotePreview = ({ quote }) => {
	const issuer = quote.issuerSnapshot;
	const isExenta = issuer?.tipoTributario === "exenta";
	const discounts =
		(quote.lineDiscountsTotal || 0) + (quote.globalDiscount?.amount || 0);

	if (!issuer) {
		return (
			<div
				style={{
					border: "1px dashed #cbd5e0",
					borderRadius: "8px",
					padding: "16px",
					color: "#718096",
				}}
			>
				Selecciona una empresa emisora para ver la vista previa.
			</div>
		);
	}

	return (
		<div
			style={{
				border: "1px solid #cbd5e0",
				borderRadius: "8px",
				background: "#fff",
				padding: "16px",
				fontSize: "13px",
			}}
		>
			<div style={{ display: "flex", justifyContent: "space-between", gap: "12px" }}>
				<div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
					<div
						style={{
							width: "42px",
							height: "42px",
							borderRadius: "6px",
							background: issuer.logoColor || "#2c3840",
							color: "#fff",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							fontWeight: 700,
						}}
					>
						{issuer.logo || "DN"}
					</div>
					<div>
						<strong>{issuer.nombreLegal}</strong>
						<div>{issuer.nombreFantasia}</div>
						<div>RUT {issuer.rut}</div>
					</div>
				</div>
				<div style={{ textAlign: "right" }}>
					<div style={{ fontSize: "16px", fontWeight: 700 }}>COTIZACIÓN</div>
					<div>{quote.number || "Sin número (borrador)"}</div>
					<CotizacionStatusBadge status={quote.status} />
				</div>
			</div>

			{isExenta ? (
				<div
					style={{
						marginTop: "12px",
						background: "#f0fff4",
						color: "#276749",
						padding: "6px 10px",
						borderRadius: "6px",
						fontWeight: 600,
					}}
				>
					Operación exenta de IVA · Documento emitido por una empresa exenta de IVA.
				</div>
			) : null}

			<hr />

			<div className="grid-x grid-margin-x">
				<div className="cell small-12 medium-6">
					<strong>Cliente</strong>
					<div>{quote.client?.nombre || "—"}</div>
					<div>RUT: {quote.client?.rut || "—"}</div>
					<div>{quote.client?.correo || ""}</div>
					<div>{quote.client?.telefono || ""}</div>
					<div>{quote.client?.domicilio || ""}</div>
					<div>{quote.client?.comuna || ""}</div>
				</div>
				<div className="cell small-12 medium-6">
					<strong>Vendedor</strong>
					<div>{quote.sellerSnapshot?.nombre || "—"}</div>
					<div>{quote.sellerSnapshot?.correo || ""}</div>
					<div>{quote.sellerSnapshot?.telefono || ""}</div>
				</div>
			</div>

			<table className="unstriped" style={{ marginTop: "12px", width: "100%" }}>
				<thead>
					<tr>
						<th>Descripción</th>
						<th>Cant.</th>
						<th>P. unit.</th>
						<th>Desc.</th>
						<th>Total</th>
					</tr>
				</thead>
				<tbody>
					{(quote.items || []).map((item) => (
						<tr key={item.id}>
							<td>
								<strong>{item.nombre}</strong>
								{item.descripcion ? (
									<div style={{ color: "#718096" }}>{item.descripcion}</div>
								) : null}
							</td>
							<td>{item.cantidad}</td>
							<td>{formatCLP(item.precioUnitario)}</td>
							<td>{formatCLP(item.montoDescuento)}</td>
							<td>{formatCLP(item.total)}</td>
						</tr>
					))}
					{(!quote.items || quote.items.length === 0) && (
						<tr>
							<td colSpan={5}>Sin productos</td>
						</tr>
					)}
				</tbody>
			</table>

			<div style={{ maxWidth: "280px", marginLeft: "auto" }}>
				<div style={{ display: "flex", justifyContent: "space-between" }}>
					<span>Subtotal</span>
					<span>{formatCLP(quote.subtotal || 0)}</span>
				</div>
				<div style={{ display: "flex", justifyContent: "space-between" }}>
					<span>Descuentos</span>
					<span>{formatCLP(discounts)}</span>
				</div>
				{isExenta ? (
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							fontWeight: 700,
							marginTop: "4px",
						}}
					>
						<span>Total exento</span>
						<span>{formatCLP(quote.grandTotal || 0)}</span>
					</div>
				) : (
					<>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<span>Neto</span>
							<span>{formatCLP(quote.netTotal || 0)}</span>
						</div>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<span>IVA {quote.taxRate || 19}%</span>
							<span>{formatCLP(quote.taxTotal || 0)}</span>
						</div>
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
								fontWeight: 700,
								marginTop: "4px",
							}}
						>
							<span>Total</span>
							<span>{formatCLP(quote.grandTotal || 0)}</span>
						</div>
					</>
				)}
			</div>

			<hr />
			<div>
				<strong>Forma de pago:</strong>{" "}
				{quote.paymentMethod === "Otra"
					? quote.customPaymentMethod
					: quote.paymentMethod || "—"}
			</div>
			<div>
				<strong>Vigencia:</strong>{" "}
				{quote.validityDays === "custom"
					? `${quote.customValidityDays || "—"} días`
					: `${quote.validityDays || 15} días`}
			</div>
			<div>
				<strong>Plazo:</strong> {quote.executionTime || "—"}
			</div>
			<div style={{ marginTop: "6px" }}>
				<strong>Condiciones:</strong>
				<div>{quote.conditions || "—"}</div>
			</div>
			{quote.notes ? (
				<div style={{ marginTop: "6px" }}>
					<strong>Observaciones:</strong>
					<div>{quote.notes}</div>
				</div>
			) : null}
		</div>
	);
};

export default QuotePreview;
